import React from 'react';
import ATSResumePdf from './ATSResumePdf';
export default function ATSModernPdf(props) { return <ATSResumePdf {...props} variant="modern" />; }